import React from 'react';
import { inputPropTypes } from '@App/common/components/Input/InputPropTypes';
import InputCommon from '@App/common/components/Input/Input';
import FormErrorText from '@Theme/natucare/components/FormErrorText/FormErrorText';
import * as styles from './Input.module.scss';
const Input = props => /*#__PURE__*/React.createElement("div", {
  className: styles.rootWrapper
}, (props === null || props === void 0 ? void 0 : props.label) && (props === null || props === void 0 ? void 0 : props.name) && /*#__PURE__*/React.createElement("label", {
  className: styles.rootLabel,
  htmlFor: props.name
}, props.label), /*#__PURE__*/React.createElement(InputCommon, Object.assign({}, props, {
  classname: `${styles.root || ''} ${props.error ? styles.rootError : ''}`
})), (props === null || props === void 0 ? void 0 : props.error) && /*#__PURE__*/React.createElement(FormErrorText, {
  text: props.errorMsg
}));
export default Input;